import { useEffect, useState } from "react";
import CustomDraggableModal from "./CustomDraggableModal";
import ValidatedDatePicker from "../inputs/ValidatedDatePicker";
import dayjs from "dayjs";
import ValidatedCheckbox from "../inputs/ValidatedCheckbox";
import ValidatedSelect from "../inputs/ValidatedSelect";
import CreatePassengerItem from "../../passengers/CreatePassengerItem";
import ValidatedTextField from "../inputs/ValidatedTextField";
import { textValidator } from "../../../helpers/validators/input-validators";
import { useDispatch, useSelector } from "react-redux";
import {
  convertDeparture,
  convertDestinations,
} from "../../../helpers/conversions/selectConversions";
import { CONTACT_TYPES, TRAVEL_TYPES } from "../../../constants/mockedData";
import LoadingModal from "./LoadingModal";
import PassengerDestinationActions from "../../passengers/PassengerDestinationActions";
import CreatePassengerModalActions from "../../passengers/CreatePassengerModalActions";
import { DESTINATION_TYPE_ENUM } from "../../../constants/enums";
import { routeActions } from "../../../store/slices/routeSlice";
import { enqueueSnackbar } from "notistack";
import SyncAltIcon from "@mui/icons-material/SyncAlt";
import { destinationActions } from "../../../store/slices/destinationSlice";
import { Box } from "@mui/material";
import PassengerSection from "../../passengers/PassengerSection";
import { TextField, Typography,Grid , Divider, Paper, Stack} from "@mui/material";
import IconButtonGroup from "./IconButtonGroup";


import { formatSerbiaTime } from "../../../config/dayjsConfig";

const CreatePassengerModal = ({
  selectedDate,
  setSelectedDate,
  isOpen,
  onClose,
  getRoutesByDestinationType,
}) => {
  const [date, setDate] = useState(dayjs().add(1, "day"));
  const [returnDate, setReturnDate] = useState(dayjs().add(1, "day"));
  const [preDestination, setPreDestination] = useState(false);
  const [postDestination, setPostDestination] = useState(false);
  const [preDepartureCity, setPreDepartureCity] = useState("");
  const [preDepartureCityAnother, setPreDepartureCityAnother] = useState("");
  const [departureCity, setDepartureCity] = useState({ value: 1, text: "" });
  const [postDepartureCity, setPostDepartureCity] = useState("");
  const [postDepartureCityAnother, setPostDepartureCityAnother] = useState("");
  const [arrivalCity, setArrivalCity] = useState("");
  const [arrivalCityAnother, setArrivalCityAnother] = useState("");
  const [preDepartureTime, setPreDepartureTime] = useState("");
  const [departureTime, setDepartureTime] = useState("");
  const [postDepartureTime, setPostDepartureTime] = useState("");
  const [departureTimeReturn, setDepartureTimeReturn] = useState("");
  const [order, setOrder] = useState(9999);
  const [orderReturn, setOrderReturn] = useState(9999);
  const [flightTime, setFlightTime] = useState("");
  const [isReturn, setIsReturn] = useState(false);
  const [note, setNote] = useState("");
  const [driverNote, setDriverNote] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [phoneNumberReturn, setPhoneNumberReturn] = useState("");
  const [contactType, setContactType] = useState("");
  const [contactTypeReturn, setContactTypeReturn] = useState("");
  const [passengers, setPassengers] = useState([]);
  const [returnPassengers, setReturnPassengers] = useState([]);
  const [price, setPrice] = useState("");
  const [priceReturn, setPriceReturn] = useState("");
  const [ages, setAges] = useState({ adult: 0, child: 0, baby: 0 });
  const [returnAges, setReturnAges] = useState({ adult: 0, child: 0, baby: 0 });
  const [seats, setSeats] = useState({ large: 0, medium: 0, small: 0 });
  const [returnSeats, setReturnSeats] = useState({
    large: 0,
    medium: 0,
    small: 0,
  });
  const [contactTypeDescription, setContactTypeDescription] = useState("");
  const [contactTypeDescriptionReturn, setContactTypeDescriptionReturn] =
    useState("");
  const [address, setAddress] = useState("");
  const [travelType, setTravelType] = useState(0);
  const [isAnotherWay, setIsAnotherWay] = useState(false);
  const [travelTypeReturn, setTravelTypeReturn] = useState(0);
  const [flightTimeReturn, setFlightTimeReturn] = useState("");
  const [addressReturn, setAddressReturn] = useState("");
  const [hasNotification, setHasNotification] = useState(false);
  const [greenPhone, setGreenPhone] = useState(false);
  const [isInactive, setIsInactive] = useState(false);
  const [wholeCar, setWholeCar] = useState(false);
  const [wholeCarReturn, setWholeCarReturn] = useState(false);
  const [wholeBus, setWholeBus] = useState(false);
  const [wholeBusReturn, setWholeBusReturn] = useState(false);
  const [isInactiveReturn, setIsInactiveReturn] = useState(false);
  const [hasQuestionmark, setHasQuestionmark] = useState(false);
  const [hasQuestionmarkReturn, setHasQuestionmarkReturn] = useState(false);
  const [sendPhoneNumber, setSendPhoneNumber] = useState(false);
  const [hasLuggage, setHasLuggage] = useState(false);
  const [hasNotificationReturn, setHasNotificationReturn] = useState(false);
  const [greenPhoneReturn, setGreenPhoneReturn] = useState(false);
  const [sendPhoneNumberReturn, setSendPhoneNumberReturn] = useState(false);
  const [hasLuggageReturn, setHasLuggageReturn] = useState(false);
  const [routeId, setRouteId] = useState(null);
  const [routesId, setRoutesId] = useState({
    firstRouteId: 0,
    secondRouteId: 0,
  });

  const { destinations, createDestinationLoading } = useSelector(
    (state) => state.destination
  );

  useEffect(() => {
    setTravelTypeReturn(travelType);
  }, [travelType]);

  const { createRouteLoading, routesByRouteId } = useSelector(
    (state) => state.route
  );
  const dispatch = useDispatch();

  const resetInputsHandler = () => {
    setDate(dayjs().add(1, "day"));
    setPreDestination(false);
    setPostDestination(false);
    setPreDepartureCity("");
    setPostDepartureCity("");
    setArrivalCity("");
    setPreDepartureTime("");
    setDepartureTime("");
    setPostDepartureTime("");
    setDepartureTimeReturn("");
    setTravelType(0);
    setTravelTypeReturn(0);
    setIsReturn(false);
    setIsAnotherWay(false);
    setNote("");
    setDriverNote("");
    setPassengers([]);
    setReturnPassengers([]);
    setHasQuestionmark(false);
    setHasQuestionmarkReturn(false);
    setAges({ adult: 0, child: 0, baby: 0 });
    setReturnAges({ adult: 0, child: 0, baby: 0 });
    setSeats({ large: 0, medium: 0, small: 0 });
    setReturnSeats({ large: 0, medium: 0, small: 0 });
    setPhoneNumber("");
    setContactType("");
    setPreDepartureCityAnother("");
    setPostDepartureCityAnother("");
    setArrivalCityAnother("");
    setContactTypeDescription("");
    setPrice("");
    setPriceReturn("");
    setHasLuggage(false);
    setHasLuggageReturn(false);
    setIsInactive(false);
    setIsInactiveReturn(false);
    setWholeCar(false);
    setWholeCarReturn(false);
    setWholeBus(false);
    setWholeBusReturn(false);
    setSendPhoneNumber(false);
    setSendPhoneNumberReturn(false);
    setHasNotification(false);
    setHasNotificationReturn(false);
    setGreenPhone(false);
    setGreenPhoneReturn(false);
    setFlightTime("");
    setFlightTimeReturn("");
    setRouteId(null);
    setRoutesId({ firstRouteId: 0, secondRouteId: 0 });
    setOrder(9999);
    setOrderReturn(9999);
  };

  useEffect(() => {
    if (routesByRouteId && routesByRouteId.length > 0) {
      let firstWay = routesByRouteId[0];
      setDate(dayjs(firstWay.date));
      setPhoneNumber(firstWay.phoneNumber);
      setAges({
        adult: firstWay.adult,
        child: firstWay.child,
        baby: firstWay.baby,
      });
      setSeats({
        large: firstWay.largeSeat,
        medium: firstWay.mediumSeat,
        small: firstWay.smallSeat,
      });
      setNote(firstWay.note);
      setDriverNote(firstWay.driverNote);
      setContactType(firstWay.contactType);
      setContactTypeDescription(firstWay.contactTypeDescription);
      setAddress(firstWay.address);
      setTravelType(firstWay.travelType);
      setFlightTime(firstWay.flightTime);
      setHasLuggage(firstWay.hasLuggage);
      setHasQuestionmark(firstWay.hasQuestionmark);
      setSendPhoneNumber(firstWay.sendPhoneNumber);
      setWholeBus(firstWay.wholeBus);
      setHasNotification(firstWay.hasNotification);
      setGreenPhone(firstWay.greenPhone);
      setIsInactive(firstWay.isInactive);
      setWholeCar(firstWay.wholeCar);
      setRouteId(firstWay.routeId);
      setRoutesId((oldState) => ({ ...oldState, firstRouteId: firstWay.id }));
      setOrder(firstWay.order);
      setPrice(firstWay.price);
      setIsAnotherWay(firstWay.isAnotherWay);

      setPassengers(
        firstWay.passengers.map((fw) => ({
          id: fw.id,
          name: fw.fullName,
          address: fw.address,
          flight: fw.flight,
          contactTel: fw.contactPhoneNumber,
          age: fw.ageType,
        }))
      );

      firstWay.routeDestinations.forEach((rd) => {
        if (rd.destination) {
          if (rd.destination.destinationType === 1) {
            setPreDepartureCity(rd.destinationId);
            setPreDepartureTime(rd.destinationTime ?? "");
            setPreDestination(true);
          }
          if (rd.destination.destinationType === 2) {
            setDepartureTime(rd.destinationTime ?? "");
          }
          if (rd.destination.destinationType === 3) {
            setPostDepartureCity(rd.destinationId);
            setPostDepartureTime(rd.destinationTime ?? "");
            setPostDestination(true);
          }
          if (rd.destination.destinationType === 4) {
            setArrivalCity(rd.destinationId);
          }
        }
      });

      if (routesByRouteId.length === 2) {
        const secondWay = routesByRouteId[1];
        setIsReturn(true);
        setReturnDate(dayjs(secondWay.date));
        setReturnAges({
          adult: secondWay.adult,
          child: secondWay.child,
          baby: secondWay.baby,
        });
        setReturnSeats({
          large: secondWay.largeSeat,
          medium: secondWay.mediumSeat,
          small: secondWay.smallSeat,
        });
        setHasLuggageReturn(secondWay.hasLuggage);
        setSendPhoneNumberReturn(secondWay.sendPhoneNumber);
        setHasNotificationReturn(secondWay.hasNotificationReturn);
        setGreenPhoneReturn(secondWay.greenPhone);
        setIsInactiveReturn(secondWay.isInactive);
        setWholeCarReturn(secondWay.wholeCar);
        setWholeBusReturn(secondWay.wholeBus);
        setPriceReturn(secondWay.price);
        setAddressReturn(secondWay.address);
        setFlightTimeReturn(secondWay.flightTime);
        setTravelTypeReturn(secondWay.travelType);
        setOrderReturn(secondWay.order);
        setRoutesId((oldState) => ({
          ...oldState,
          secondRouteId: secondWay.id,
        }));

        secondWay.routeDestinations.forEach((rd) => {
          if (rd.destination) {
            if (rd.destination.destinationType === 2) {
              setDepartureTimeReturn(rd.destinationTime ?? "");
            }
          }
        });

        setReturnPassengers(
          secondWay.passengers.map((fw) => ({
            id: fw.id,
            name: fw.fullName,
            address: fw.address,
            flight: fw.flight,
            contactTel: fw.contactPhoneNumber,
            age: fw.ageType,
          }))
        );
      }
    }
  }, [routesByRouteId]);

  useEffect(() => {
    if (!isReturn) return;

    if (returnPassengers.length === 0 && passengers.length > 0) {
      setReturnPassengers(
        passengers.map((passenger) => ({
          ...passenger,
        }))
      );
      setReturnAges({ ...ages });
    }
  }, [isReturn, passengers, returnPassengers.length, ages]);

  useEffect(() => {
    if (destinations.length > 0) {
      const np = convertDeparture(destinations);
      if (np && np[0]) {
        setDepartureCity({ value: np[0].value, text: np[0].title });
      }
    }
  }, [destinations]);

  const createRouteDestinationsForm = (isReturnWay = false) => {
    const routeDestinationsForm = [];

    if (preDestination && preDepartureCity !== "") {
      routeDestinationsForm.push({
        destinationId: preDepartureCity,
        destinationTime: preDepartureTime ? preDepartureTime : null,
      });
    }

    if (departureCity.text !== "") {
      let departureCityTime = "";
      if (isReturnWay) {
        departureCityTime = departureTimeReturn;
      } else {
        departureCityTime = departureTime;
      }

      routeDestinationsForm.push({
        destinationId: departureCity.value,
        destinationTime: departureCityTime ? departureCityTime : null,
      });
    }

    if (postDestination && postDepartureCity !== "") {
      routeDestinationsForm.push({
        destinationId: postDepartureCity,
        destinationTime: postDepartureTime ? postDepartureTime : null,
      });
    }

    if (arrivalCity) {
      routeDestinationsForm.push({
        destinationId: arrivalCity,
      });
    }

    return routeDestinationsForm;
  };

  const createPassengersForm = (arr) => {
    const passengersForm = arr.map((pass) => ({
      id: pass.id ?? 0,
      fullName: pass.name,
      address: pass.address,
      flight: pass.flight,
      contactPhoneNumber: pass.contactTel,
      ageType: Number(pass.age),
    }));

    return passengersForm;
  };

  const createPassengerForm = (isEdit = false) => {
    const form = { routeId, routes: [] };
    const firstWay = {
      id: routesId.firstRouteId > 0 ? routesId.firstRouteId : undefined,
      phoneNumber,
      largeSeat: seats.large,
      mediumSeat: seats.medium,
      smallSeat: seats.small,
      note,
      driverNote,
      isReturn: false,
      adult: ages.adult,
      child: ages.child,
      baby: ages.baby,
      contactType: Number(contactType),
      contactTypeDescription,
      routeDestinations: [],
      passengers: [],
      order,
      date: formatSerbiaTime(date),
      flightTime,
      address,
      travelType,
      isAnotherWay,
      hasLuggage,
      hasNotification,
      greenPhone,
      hasQuestionmark,
      isInactive,
      wholeCar,
      wholeBus,
      sendPhoneNumber,
      price,
    };

    if (isEdit === false) firstWay.order = 9999;

    firstWay.routeDestinations = createRouteDestinationsForm();
    firstWay.passengers = createPassengersForm(passengers);

    form.routes.push(firstWay);

    if (isReturn) {
      const secondWay = {
        id: routesId.secondRouteId > 0 ? routesId.secondRouteId : undefined,
        phoneNumber: phoneNumberReturn,
        largeSeat: returnSeats.large,
        mediumSeat: returnSeats.medium,
        smallSeat: returnSeats.small,
        note,
        driverNote,
        isReturn: true,
        adult: returnAges.adult,
        child: returnAges.child,
        baby: returnAges.baby,
        contactType: Number(contactTypeReturn),
        contactTypeDescription: contactTypeDescriptionReturn,
        routeDestinations: [],
        order: orderReturn,
        passengers: [],
        date: returnDate,
        flightTime: flightTimeReturn,
        address: addressReturn,
        travelType: travelTypeReturn,
        isAnotherWay: !isAnotherWay,
        hasLuggage: hasLuggageReturn,
        hasNotification: hasNotificationReturn,
        greenPhone: greenPhoneReturn,
        hasQuestionmark: hasQuestionmarkReturn,
        isInactive: isInactiveReturn,
        wholeCar: wholeCarReturn,
        wholeBus: wholeBusReturn,
        sendPhoneNumber: sendPhoneNumberReturn,
        price: priceReturn,
      };

      if (isEdit === false) secondWay.order = 9999;

      secondWay.routeDestinations = createRouteDestinationsForm(true);
      secondWay.passengers = createPassengersForm(returnPassengers);

      form.routes.push(secondWay);
    }

    return form;
  };

  const onSuccessfullyCreatedRoute = () => {
    dispatch(destinationActions.destinationsByDateFetch(selectedDate));
    getRoutesByDestinationType();
    enqueueSnackbar("Uspešno kreirana ruta!", { variant: "success" });
    onClose();
    resetInputsHandler();
  };

  const onErrorCreatedRoute = () => {
    resetInputsHandler();
    enqueueSnackbar("Neuspešno kreirana ruta!", { variant: "error" });
  };

  const addReservationHandler = () => {
    let form = createPassengerForm();

    if (!arrivalCity || arrivalCity === "") {
      alert("Dolazak mora biti unet");
      return;
    }

    setSelectedDate(date)

    dispatch(
      routeActions.createRoutePost({
        routes: [...form.routes],
        onSuccessfullyCreatedRoute,
        onErrorCreatedRoute,
      })
    );
  };

  const updateReservationHandler = () => {
    let form = createPassengerForm(true);

    let passengersWithId = passengers
      .filter((x) => x.id !== undefined)
      .map((x) => x.id);

    let returnPassengersWithId = returnPassengers
      .filter((x) => x.id !== undefined)
      .map((x) => x.id);

    const fw = form.routes.find((x) => x.isReturn === false);
    if (fw) fw.passengersIds = passengersWithId;

    const sw = form.routes.find((x) => x.isReturn === true);
    if (sw) sw.passengersIds = returnPassengersWithId;

    setSelectedDate(date);

    dispatch(
      routeActions.updateRoutePut({
        form,
        routeId: form.routeId,
        onSuccessUpdateRoute,
      })
    );
  };

  const onSuccessUpdateRoute = () => {
    getRoutesByDestinationType();
    onClose();
    resetInputsHandler();
    dispatch(destinationActions.destinationsByDateFetch(date));
  };

  useEffect(() => {
    if (preDestination === true) {
      setPostDestination(false);
    }
  }, [preDestination]);

  useEffect(() => {
    if (postDestination === true) {
      setPreDestination(false);
    }
  }, [postDestination]);

  const handlePassengerUpdate = (id, fieldName, newValue, setState) => {
    setState((prevPassengers) =>
      prevPassengers.map((passenger, index) =>
        index === id ? { ...passenger, [fieldName]: newValue } : passenger
      )
    );
  };

  const handleDeletePassengerFromList = (
    id,
    passengersState,
    setAgesState,
    setPassengersState
  ) => {
    const tmp = passengersState.filter((_, index) => id === index);

    if (tmp[0].age === 1)
      setAgesState((oldVal) => ({ ...oldVal, adult: oldVal.adult - 1 }));
    else if (tmp[0].age === 2)
      setAgesState((oldVal) => ({ ...oldVal, child: oldVal.child - 1 }));
    else if (tmp[0].age === 3)
      setAgesState((oldVal) => ({ ...oldVal, baby: oldVal.baby - 1 }));

    setPassengersState((oldVal) => oldVal.filter((_, index) => id !== index));
  };

  useEffect(() => {
    if (ages.child === 0 && ages.baby === 0) {
      if (seats.large > 0) setSeats((oldVal) => ({ ...oldVal, large: 0 }));
      if (seats.medium > 0) setSeats((oldVal) => ({ ...oldVal, medium: 0 }));
      if (seats.small > 0) setSeats((oldVal) => ({ ...oldVal, small: 0 }));
    }
  }, [ages, seats]);

  useEffect(() => {
    if (returnAges.child === 0 && returnAges.baby === 0) {
      if (returnSeats.large > 0)
        setReturnSeats((oldVal) => ({ ...oldVal, large: 0 }));
      if (returnSeats.medium > 0)
        setReturnSeats((oldVal) => ({ ...oldVal, medium: 0 }));
      if (returnSeats.small > 0)
        setReturnSeats((oldVal) => ({ ...oldVal, small: 0 }));
    }
  }, [returnAges, returnSeats]);

  const changeDirectionHandler = () => {
    setIsAnotherWay((oldState) => !oldState);
  };

  if (createDestinationLoading || createRouteLoading) {
    return <LoadingModal />;
  }

  const handleCloseWithRestartModal = () => {
    onClose();
    resetInputsHandler();
  };


  
 return (
    <CustomDraggableModal isOpen={isOpen} onClose={handleCloseWithRestartModal}>
      {/* Header */}
      <Box sx={{ mb: 3 }}>
        <Typography variant="h6" sx={{ fontWeight: 600 }}>
          Dodajte rezervaciju
        </Typography>
      </Box>

      {/* DATUM */}
      <Box sx={{ mb: 3 }}>
        <Typography 
          variant="caption" 
          sx={{ 
            fontWeight: 600, 
            color: 'text.secondary',
            textTransform: 'uppercase',
            letterSpacing: '0.5px',
            display: 'block',
            mb: 2
          }}
        >
          Datum
        </Typography>

        <Grid container spacing={2}>
          <Grid item xs={12} md={isReturn ? 6 : 12}>
            <ValidatedDatePicker
              value={date}
              setValue={setDate}
              label="Datum polaska"
              format="dd/MM/yyyy"
            />
          </Grid>

          {isReturn && (
            <Grid item xs={12} md={6}>
              <ValidatedDatePicker
                value={returnDate}
                setValue={setReturnDate}
                label="Datum povratka"
                format="dd/MM/yyyy"
                minDate={date}
              />
            </Grid>
          )}
        </Grid>
      </Box>
      
    <Box sx={{ mb: 2 }}>
    <Typography
      variant="subtitle2"
      sx={{
        fontWeight: 600,
        textTransform: "uppercase",
        letterSpacing: "1px",
        mb: 1,
        lineHeight: 1.2,
        fontSize: "0.75rem",
      }}
    >
      Relacija
    </Typography>


      <Paper
        elevation={0}
        sx={{
          display: "flex",
          gap: 1.5,
          p: 0.5,
          borderRadius: 2,
          flexWrap: "wrap",
        }}
      >
        <Box
          onClick={() => setPreDestination(!preDestination)}
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 0.5,
            px: 1.5,
            py: 0.5,
            borderRadius: 1,
            cursor: "pointer",
            border: 2,
            borderColor: preDestination ? "#6366f1" : "#e5e7eb",
            bgcolor: preDestination ? "#eef2ff" : "#fff",
            "&:hover": {
              borderColor: "#6366f1",
              bgcolor: "#f3f4f6",
            },
            transition: "all 0.2s ease",
          }}
        >
          <ValidatedCheckbox
            value={preDestination}
            setValue={setPreDestination}
            sx={{ color: "#6366f1", "&.Mui-checked": { color: "#6366f1" }, p: 0 }}
          />
          <Typography
            variant="body2"
            sx={{
              fontWeight: 600,
              fontSize: "0.75rem",
              color: preDestination ? "#6366f1" : "#6c757d",
            }}
          >
            Pre
          </Typography>
        </Box>

        {/* POSLE */}
        <Box
          onClick={() => setPostDestination(!postDestination)}
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 0.5,
            px: 1.5,
            py: 0.5,
            borderRadius: 1,
            cursor: "pointer",
            border: 2,
            borderColor: postDestination ? "#6366f1" : "#e5e7eb",
            bgcolor: postDestination ? "#eef2ff" : "#fff",
            "&:hover": {
              borderColor: "#6366f1",
              bgcolor: "#f3f4f6",
            },
            transition: "all 0.2s ease",
          }}
        >
          <ValidatedCheckbox
            value={postDestination}
            setValue={setPostDestination}
            sx={{ color: "#6366f1", "&.Mui-checked": { color: "#6366f1" }, p: 0 }}
          />
          <Typography
            variant="body2"
            sx={{
              fontWeight: 600,
              fontSize: "0.75rem",
              color: postDestination ? "#6366f1" : "#6c757d",
            }}
          >
            Posle
          </Typography>
        </Box>
      </Paper>
    </Box>
      {/* GLAVNI BLOK */}
     
       <Box sx={{ mb: 3 }}>
  <Stack
    direction={{ xs: "column", md: "row" }}
    spacing={2}
    alignItems="center"
  >
    {/* PRE POLAZAK */}
    {preDestination && !postDestination && (
      <Box sx={{ flex: 1, minWidth: 120 }}>
        {preDepartureCity !== -1 ? (
          <ValidatedSelect
            label="Pre polazak"
            options={convertDestinations(destinations, DESTINATION_TYPE_ENUM.PreDepartureLocation)}
            value={preDepartureCity}
            setValue={setPreDepartureCity}
          />
        ) : (
          <Box>
            <ValidatedTextField
              value={preDepartureCityAnother}
              setValue={setPreDepartureCityAnother}
              label="Pre polazak"
              validator={textValidator}
              type="text"
            />
           <div className="full-display-flex mt-2">
                      <PassengerDestinationActions
                        setCity={setPreDepartureCity}
                        setCityAnother={setPreDepartureCityAnother}
                        value={preDepartureCityAnother}
                        enumValue={DESTINATION_TYPE_ENUM.PreDepartureLocation}
                      />
                    </div>
          </Box>
        )}
      </Box>
    )}

    <Stack
      direction="row"
      spacing={1}
      sx={{
        flex: 1,
        alignItems: "center",
      }}
    >
      {/* Levo */}
      <Box sx={{ flex: 1 }}>
        {isAnotherWay && arrivalCity === -1 ? (
          <Box>
            <ValidatedTextField
              value={arrivalCityAnother}
              setValue={setArrivalCityAnother}
              label="Dolazak"
              validator={textValidator}
              type="text"
            />
            <div className="full-display-flex mt-2">
              <PassengerDestinationActions
                setCity={setArrivalCity}
                setCityAnother={setArrivalCityAnother}
                value={arrivalCityAnother}
                enumValue={DESTINATION_TYPE_ENUM.ArrivalLocation}
              />
            </div>
          </Box>
        ) : (
          <ValidatedSelect
            label={isAnotherWay ? "Dolazak" : "Polazak"}
            options={isAnotherWay
              ? convertDestinations(destinations, DESTINATION_TYPE_ENUM.ArrivalLocation)
              : [{ value: departureCity.id || 0, title: departureCity.text || "—" }]}
            value={isAnotherWay ? arrivalCity : departureCity.id || 0}
            setValue={isAnotherWay ? setArrivalCity : () => {}}
            disabled={!isAnotherWay}
            bolded
          />
        )}
      </Box>

      {/* Switch button */}
      <Box
        component="button"
        onClick={changeDirectionHandler}
        sx={{
          width: 36,
          height: 36,
          minWidth: 36,
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "#fff",
          border: "1px solid #6366f1",
          color: "#6366f1",
          cursor: "pointer",
          p: 0,
          transition: "all 0.2s ease",
          "&:hover": {
            backgroundColor: "#6366f1",
            color: "#fff",
          },
        }}
      >
        <SyncAltIcon fontSize="small" />
      </Box>

      {/* Desno */}
      <Box sx={{ flex: 1 }}>
        {!isAnotherWay && arrivalCity === -1 ? (
          <Box>
            <ValidatedTextField
              value={arrivalCityAnother}
              setValue={setArrivalCityAnother}
              label="Dolazak"
              validator={textValidator}
              type="text"
            />
            <div className="full-display-flex mt-2">
              <PassengerDestinationActions
                setCity={setArrivalCity}
                setCityAnother={setArrivalCityAnother}
                value={arrivalCityAnother}
                enumValue={DESTINATION_TYPE_ENUM.ArrivalLocation}
              />
            </div>
          </Box>
        ) : (
          <ValidatedSelect
            label={isAnotherWay ? "Polazak" : "Dolazak"}
            options={isAnotherWay
              ? [{ value: departureCity.id || 0, title: departureCity.text || "—" }]
              : convertDestinations(destinations, DESTINATION_TYPE_ENUM.ArrivalLocation)}
            value={isAnotherWay ? departureCity.id || 0 : arrivalCity}
            setValue={isAnotherWay ? () => {} : setArrivalCity}
            disabled={isAnotherWay ? true : false}
            bolded
          />
        )}
      </Box>
    </Stack>

    {/* POSLE POLAZAK */}
    {postDestination && !preDestination && (
      <Box sx={{ flex: 1, minWidth: 120 }}>
        {postDepartureCity !== -1 ? (
          <ValidatedSelect
            label="Posle polazak"
            options={convertDestinations(destinations, DESTINATION_TYPE_ENUM.PostDepartureLocation)}
            value={postDepartureCity}
            setValue={setPostDepartureCity}
          />
        ) : (
          <Box>
            <ValidatedTextField
              value={postDepartureCityAnother}
              setValue={setPostDepartureCityAnother}
              label="Posle polazak"
              validator={textValidator}
              type="text"
            />
            <Box sx={{ mt: 1 }}>
              <PassengerDestinationActions
                setCity={setPostDepartureCity}
                setCityAnother={setPostDepartureCityAnother}
                value={postDepartureCityAnother}
                enumValue={DESTINATION_TYPE_ENUM.PostDepartureLocation}
              />
            </Box>
          </Box>
        )}
      </Box>
    )}
  </Stack>
</Box>

      {/* VREME POLASKA */}
      <Box sx={{ mb: 3 }}>
        <Typography 
          variant="caption" 
          sx={{ 
            fontWeight: 600, 
            color: 'text.secondary',
            textTransform: 'uppercase',
            letterSpacing: '0.5px',
            display: 'block',
            mb: 2
          }}
        >
          Vreme polaska
        </Typography>

        <Box sx={{ display: 'flex', gap: 1.5 }}>
          {preDestination && !postDestination && (
            <Box sx={{ flex: 1 }}>
              <ValidatedTextField
                value={preDepartureTime ?? ""}
                setValue={setPreDepartureTime}
                label="Pre polazak"
                validator={textValidator}
                type="text"
                fullWidth
              />
            </Box>
          )}

          <Box sx={{ flex: 1 }}>
            <ValidatedTextField
              value={departureTime ?? ""}
              setValue={setDepartureTime}
              label="Polazak"
              validator={textValidator}
              type="text"
              fullWidth
            />
          </Box>

          {postDestination && !preDestination && (
            <Box sx={{ flex: 1 }}>
              <ValidatedTextField
                value={postDepartureTime ?? ""}
                setValue={setPostDepartureTime}
                label="Posle polazak"
                validator={textValidator}
                type="text"
                fullWidth
              />
            </Box>
          )}
        </Box>
      </Box>

      {/* VREME LETA */}
      <Box sx={{ mb: 3 }}>
        <Typography 
          variant="caption" 
          sx={{ 
            fontWeight: 600, 
            color: 'text.secondary',
            textTransform: 'uppercase',
            letterSpacing: '0.5px',
            display: 'block',
            mb: 2
          }}
        >
          Vreme leta
        </Typography>

        <Grid container spacing={2}>
          <Grid item xs={12} lg={4}>
            <ValidatedSelect
              label="Tip putovanja"
              options={TRAVEL_TYPES}
              value={travelType}
              setValue={setTravelType}
            />
          </Grid>

          <Grid item xs={12} lg={4}>
            <ValidatedTextField
              value={flightTime}
              setValue={setFlightTime}
              label="Vreme leta"
              validator={textValidator}
              type="text"
            />
          </Grid>

          <Grid item xs={12} lg={4}>
            <ValidatedTextField
              value={address}
              setValue={setAddress}
              label="Adresa"
              validator={textValidator}
              type="text"
            />
          </Grid>
        </Grid>
      </Box>

      <IconButtonGroup
        wholeCar={wholeCar} setWholeCar={setWholeCar}
        wholeBus={wholeBus} setWholeBus={setWholeBus}
        isInactive={isInactive} setIsInactive={setIsInactive}
        hasQuestionmark={hasQuestionmark} setHasQuestionmark={setHasQuestionmark}
        hasNotification={hasNotification} setHasNotification={setHasNotification}
        sendPhoneNumber={sendPhoneNumber} setSendPhoneNumber={setSendPhoneNumber}
        hasLuggage={hasLuggage} setHasLuggage={setHasLuggage}
        greenPhone={greenPhone} setGreenPhone={setGreenPhone}
      />

      <PassengerSection
        ages={ages}
        setAges={setAges}
        setReturnAges={setReturnAges}
        passengers={passengers}
        setPassengers={setPassengers}
        returnPassengers={returnPassengers}
        setReturnPassengers={setReturnPassengers}
        seats={seats}
        returnSeats={returnSeats}
        setSeats={setSeats}
        setReturnSeats={setReturnSeats}
        handlePassengerUpdate={handlePassengerUpdate}
        handleDeletePassengerFromList={handleDeletePassengerFromList}
      />

      {/* GLAVNI KONTAKT */}
      <Box sx={{ mb: 3 }}>
        <Typography 
          variant="caption" 
          sx={{ 
            fontWeight: 600, 
            color: 'text.secondary',
            textTransform: 'uppercase',
            letterSpacing: '0.5px',
            display: 'block',
            mb: 2
          }}
        >
          Glavni kontakt
        </Typography>

        <Box sx={{ display: 'flex', gap: 1.5 }}>
          <Box sx={{ flex: 2 }}>
            <ValidatedTextField
              value={phoneNumber}
              setValue={setPhoneNumber}
              label="Glavni kontakt"
              validator={textValidator}
              type="text"
            />
          </Box>
          <Box sx={{ flex: 1 }}>
            {contactType !== 7 ? (
              <ValidatedSelect
                label="Tip"
                options={CONTACT_TYPES}
                value={contactType}
                setValue={setContactType}
              />
            ) : (
              <ValidatedTextField
                value={contactTypeDescription}
                setValue={setContactTypeDescription}
                label="Tip"
                validator={textValidator}
                type="text"
              />
            )}
          </Box>
        </Box>
      </Box>

      {/* CENA */}
      <Box sx={{ mb: 3 }}>
        <Typography 
          variant="caption" 
          sx={{ 
            fontWeight: 600, 
            color: 'text.secondary',
            textTransform: 'uppercase',
            letterSpacing: '0.5px',
            display: 'block',
            mb: 2
          }}
        >
          Cena
        </Typography>

        <ValidatedTextField
          value={price}
          setValue={setPrice}
          label="CENA"
          validator={textValidator}
          type="text"
          fullWidth
        />
      </Box>

      {/* POVRATAK CHECKBOX */}
      <Box
        sx={{
          backgroundColor: '#f9fafb',
          padding: '12px 16px',
          borderRadius: 2,
          display: 'flex',
          alignItems: 'center',
          gap: 1.5,
          mb: 3,
        }}
      >
        <Typography 
          variant="caption" 
          sx={{ 
            fontWeight: 600, 
            color: 'text.secondary',
            textTransform: 'uppercase',
            letterSpacing: '0.5px',
            m: 0
          }}
        >
          Povratak
        </Typography>
        <ValidatedCheckbox value={isReturn} setValue={setIsReturn} />
      </Box>

      {/* POVRATAK SEKCIJA */}
      {isReturn && (
        <>
          <Divider sx={{ my: 3 }} />

          {/* Datum povratka */}
          <Box sx={{ mb: 3 }}>
            <Typography 
              variant="caption" 
              sx={{ 
                fontWeight: 600, 
                color: 'text.secondary',
                textTransform: 'uppercase',
                letterSpacing: '0.5px',
                display: 'block',
                mb: 2
              }}
            >
              Datum
            </Typography>
            <ValidatedDatePicker
              value={returnDate}
              setValue={setReturnDate}
              label="Povratak"
              minDate
            />
          </Box>

          {/* Vreme polaska povratak */}
          <Box sx={{ mb: 3 }}>
            <Typography 
              variant="caption" 
              sx={{ 
                fontWeight: 600, 
                color: 'text.secondary',
                textTransform: 'uppercase',
                letterSpacing: '0.5px',
                display: 'block',
                mb: 2
              }}
            >
              Vreme polaska
            </Typography>
            <ValidatedTextField
              value={departureTimeReturn ?? ""}
              setValue={setDepartureTimeReturn}
              label="Vreme polaska"
              validator={textValidator}
              type="text"
            />
          </Box>

          {/* Vreme leta povratak */}
          <Box sx={{ mb: 3 }}>
            <Typography 
              variant="caption" 
              sx={{ 
                fontWeight: 600, 
                color: 'text.secondary',
                textTransform: 'uppercase',
                letterSpacing: '0.5px',
                display: 'block',
                mb: 2
              }}
            >
              Vreme leta
            </Typography>

            <Grid container spacing={2}>
              <Grid item xs={12} lg={4}>
                <ValidatedSelect
                  label="Tip putovanja"
                  options={TRAVEL_TYPES}
                  value={travelTypeReturn}
                  setValue={setTravelTypeReturn}
                />
              </Grid>
              <Grid item xs={12} lg={4}>
                <ValidatedTextField
                  value={flightTimeReturn}
                  setValue={setFlightTimeReturn}
                  label="Vreme leta"
                  validator={textValidator}
                  type="text"
                />
              </Grid>
              <Grid item xs={12} lg={4}>
                <ValidatedTextField
                  value={addressReturn}
                  setValue={setAddressReturn}
                  label="Adresa"
                  validator={textValidator}
                  type="text"
                />
              </Grid>
            </Grid>
          </Box>

          <IconButtonGroup
            wholeCar={wholeCarReturn} setWholeCar={setWholeCarReturn}
            wholeBus={wholeBusReturn} setWholeBus={setWholeBusReturn}
            isInactive={isInactiveReturn} setIsInactive={setIsInactiveReturn}
            hasQuestionmark={hasQuestionmarkReturn} setHasQuestionmark={setHasQuestionmarkReturn}
            hasNotification={hasNotificationReturn} setHasNotification={setHasNotificationReturn}
            sendPhoneNumber={sendPhoneNumberReturn} setSendPhoneNumber={setSendPhoneNumberReturn}
            hasLuggage={hasLuggageReturn} setHasLuggage={setHasLuggageReturn}
            greenPhone={greenPhoneReturn} setGreenPhone={setGreenPhoneReturn}
          />

          <PassengerSection
            isReturn={true}
            ages={returnAges}
            setAges={setAges}
            setReturnAges={setReturnAges}
            passengers={passengers}
            setPassengers={setPassengers}
            returnPassengers={returnPassengers}
            setReturnPassengers={setReturnPassengers}
            seats={returnSeats}
            setSeats={setSeats}
            setReturnSeats={setReturnSeats}
            handlePassengerUpdate={handlePassengerUpdate}
            handleDeletePassengerFromList={handleDeletePassengerFromList}
          />

          {/* Glavni kontakt povratak */}
          <Box sx={{ mb: 3 }}>
            <Typography 
              variant="caption" 
              sx={{ 
                fontWeight: 600, 
                color: 'text.secondary',
                textTransform: 'uppercase',
                letterSpacing: '0.5px',
                display: 'block',
                mb: 2
              }}
            >
              Glavni kontakt
            </Typography>

            <Box sx={{ display: 'flex', gap: 1.5 }}>
              <Box sx={{ flex: 2 }}>
                <ValidatedTextField
                  value={phoneNumberReturn}
                  setValue={setPhoneNumberReturn}
                  label="Glavni kontakt"
                  validator={textValidator}
                  type="text"
                />
              </Box>
              <Box sx={{ flex: 1 }}>
                {contactType !== 7 ? (
                  <ValidatedSelect
                    label="Tip"
                    options={CONTACT_TYPES}
                    value={contactTypeReturn}
                    setValue={setContactTypeReturn}
                  />
                ) : (
                  <ValidatedTextField
                    value={contactTypeDescriptionReturn}
                    setValue={setContactTypeDescriptionReturn}
                    label="Tip"
                    validator={textValidator}
                    type="text"
                  />
                )}
              </Box>
            </Box>
          </Box>

          {/* Cena povratak */}
          <Box sx={{ mb: 3 }}>
            <Typography 
              variant="caption" 
              sx={{ 
                fontWeight: 600, 
                color: 'text.secondary',
                textTransform: 'uppercase',
                letterSpacing: '0.5px',
                display: 'block',
                mb: 2
              }}
            >
              Cena
            </Typography>

            <ValidatedTextField
              value={priceReturn}
              setValue={setPriceReturn}
              label="CENA"
              validator={textValidator}
              type="text"
            />
          </Box>
        </>
      )}

      {/* NAPOMENE */}
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mb: 3 }}>
        <Box>
          <Typography 
            variant="subtitle2" 
            sx={{ fontWeight: 600, color: 'text.secondary', mb: 1 }}
          >
            Napomena (interno)
          </Typography>
          <TextField
            value={note}
            onChange={(e) => setNote(e.target.value)}
            placeholder="Unesite internu napomenu..."
            multiline
            minRows={4}
            fullWidth
            variant="outlined"
            sx={{
              '& .MuiOutlinedInput-root': {
                borderRadius: 2,
                fontSize: '14px',
                backgroundColor: '#f9fafb',
              },
              '& .MuiOutlinedInput-notchedOutline': {
                borderColor: '#d1d5db',
              },
              '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
                borderColor: '#6366f1',
              },
            }}
          />
        </Box>

        <Box>
          <Typography 
            variant="subtitle2" 
            sx={{ fontWeight: 600, color: 'text.secondary', mb: 1 }}
          >
            Napomena za vozača
          </Typography>
          <TextField
            value={driverNote}
            onChange={(e) => setDriverNote(e.target.value)}
            placeholder="Unesite napomenu koja će biti vidljiva vozaču..."
            multiline
            minRows={4}
            fullWidth
            variant="outlined"
            sx={{
              '& .MuiOutlinedInput-root': {
                borderRadius: 2,
                fontSize: '14px',
                backgroundColor: '#f9fafb',
              },
              '& .MuiOutlinedInput-notchedOutline': {
                borderColor: '#d1d5db',
              },
              '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
                borderColor: '#6366f1',
              },
            }}
          />
        </Box>
      </Box>

      <CreatePassengerModalActions
        handleClose={handleCloseWithRestartModal}
        handleInputsReset={resetInputsHandler}
        handleAddingReservation={addReservationHandler}
        isUpdate={routesByRouteId?.length > 0}
        handleUpdatingReservation={updateReservationHandler}
      />
    </CustomDraggableModal>
  );
};

export default CreatePassengerModal;